//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apiConst from '../service/api/api-const'
import baseInfoHeader from './base_info_header'
export default {
  name: 'baby_live',
  components:{
    baseInfoHeader
  },
  data () {
    return {
      indexList:'',
      showSearch:true,
      has_answer:'',//是否填过答案
      id:this.$route.query.id,
      member_column_list: [],//表单数组
      column_list: [],//表单数组
      is_drapList:false,
      //孕妇列表
      maternal_list:[],
      //签名
      is_edit:true,//是否显示
      tmpImageUpload:{},
      option:{
				penColor:"rgb(0, 0, 0)"
      },
      host:apiConst.host,
      pinyin_array:[]
    }
  },
  methods: {
    //替换所有换行符
    replaceAllNewLine(content)    {    
      var string = content;    
      try{    
          string=string.replace(/\r\n/g,"<br>");    
          string=string.replace(/\n/g,"<br>");    
      }catch(e) {    
          // alert(e.message);    
      }    
      return string;    
    }, 

    //替换br成换行
    replaceAllBr(content)    {    
      var string = content;    
      try{    
          string=string.replace("<br>", "\n").replace("<br>", "\n");    
          string=string.replace("<br>", "\n"); 
      }catch(e) {    
          // alert(e.message);    
      }    
      return string;    
    },
    textareaBlur(id){
      for(let column_list_item of this.column_list){
        for(let row_list_item of column_list_item.row_list){
          for(let content_item of row_list_item.content){
            if(content_item.id == id){
              content_item.my_answer = this.replaceAllBr(content_item.my_answer)
            }
          }
        }
      }
    },
    isInArray(arr,value){
        for(let item of arr){
            if(value === item){
                return true;
            }
        }
        return false;
    },
    selece_cfr(name,id){
      for(let column_list_item of this.column_list){
        for(let row_list_item of column_list_item.row_list){
          for(let content_item of row_list_item.content){
            if(content_item.id == id){
              content_item.my_answer = [name]
              this.indexList = ''
            }
          }
        }
      }
    },
    selectPeople(id){
      if(this.indexList){
        this.indexList = ''
        return
      }
      this.indexList = id
    },
    arrar_sort(newArr,oldArr){
      let newList = []
      let pyArrSort = newArr.sort()
      let i=0;
      for(let item of pyArrSort){
        for(let list of oldArr){
          if(item == list.pinyin){
              newList[i] = list
          }
        }
        i++
      }
      return newList
    },
    cfr_list(arr){
      if(arr.length){
        let nurser_name_arr = []
        for(let item of arr){
          let _py = ((py.ConvertPinyin(item.user_name)).substr(0, 1)).toUpperCase()            
          let obj ={
            name:[item.user_name],
            pinyin:_py
          }
          nurser_name_arr.push(obj)
        }
        let pyArr =[]
        for(let item of nurser_name_arr){
          let obj ={
            name:item.name,
            pinyin:item.pinyin
          }
          let is_have = this.isInArray(pyArr,item.pinyin)
          if(!is_have){
              //不存在
              pyArr.push(item.pinyin) 
              this.pinyin_array.push(item.pinyin) 
              this.pinyin_array.sort()
              this.maternal_list.push(obj)
          }else{
              //存在
              let _index = pyArr.indexOf(item.pinyin)
              this.maternal_list[_index].name.push((item.name).join(''))
          }
        }
        this.maternal_list = this.arrar_sort(pyArr,this.maternal_list)
      }
    },
    //获取查房人列表
    apiGetCfrList(){
        let params = {
            token: this.$cookie.get('token'),
            store_id:this.$cookie.get('store_id'),
        }
        Api.checkRoomApi.getCheckInfo(params).then ( res => {
            console.info("获取查房人列表")
            console.info(res)
            if(res.errcode == 1){
                this.cfr_list(res.data.nurser_name)

            }else{
                this.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo,
                }) 
            }
        })
    },
    //请求孕妇表单配置信息
    apiBabyLive () {
      this.$vux.loading.show({
        text: '正在加载'
      })
      let params = {
        token: this.$cookie.get('token'),
        child_id: this.$route.query.child_id
      }
      Api.babyLiveApi.babyEvaluationSheet(params).then ( res => {
        console.log('宝宝入住',res)
        if(res.errcode == 1){
          this.has_answer = res.data.has_answer
          this.member_column_list = res.data.column_list
          for(let column_list_item of res.data.form_data.column_list){
            for(let row_list_item of column_list_item.row_list){
              for(let content_item of row_list_item.content){
                for(let item of this.member_column_list){
                  if(content_item.column_name == item.name){
                    content_item.tip = item.value
                    this.$vux.loading.hide()
                  }
                }
              }
            }
          }
          this.column_list = res.data.form_data.column_list
          //孕妇列表
          this.cfr_list(res.data.nurser_name)
          // this.apiGetCfrList()
          this.$vux.loading.hide()
        }else{
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //是否提交过答案
    editForm(){
      this.has_answer = '2'
    },
    input_focus(id){
        this.is_drapList = id
    },
    menuClick(name,id){
      for(let column_list_item of this.column_list){
        for(let row_list_item of column_list_item.row_list){
          for(let content_item of row_list_item.content){
            if(content_item.id == id){
              content_item.my_answer = [name]
              this.is_drapList = ''
            }
          }
        }
      }
    },
    //保存签名
    save(id){
      let signature ='signature'+id
			var png = this.$refs[signature][0].save()
			var jpeg = this.$refs[signature][0].save('image/jpeg')
      var svg = this.$refs[signature][0].save('image/svg+xml');
      for(let column_list_item of this.column_list){
        for(let row_list_item of column_list_item.row_list){
          for(let content_item of row_list_item.content){
            if(content_item.id == id){
              content_item.my_answer = [encodeURI(png)]
              this.is_edit = ''
            }
          }
        }
      }
    },
    //清除签名
		clear(id){
      let signature ='signature'+id
      let refs = this.$refs[signature][0].clear()
    },
    //编辑签名
    edit_signature(id){
      this.is_edit = id
    },
    //图片上传
    fileImage(e){
      var file = e.target.files[0];
      var item_id = e.target.id
      var that=this;
      lrz(file)
      .then(function (rst) {
          // 处理成功会执行
          for(let column_list_item of that.column_list){
              for(let row_list_item of column_list_item.row_list){
                  for(let content_item of row_list_item.content){
                      if(content_item.id == item_id){
                          if(content_item.my_answer.length == 10){
                              that.$vux.toast.show({
                                  type: 'cancel',
                                  text: '最多上传10张图片',
                              })
                              return
                          }
                          content_item.my_answer.push(rst.base64)
                      }
                  }
              }
          }
      })
      .catch(function (err) {
        console.info(err)
        that.$vux.toast.show({
            type: 'cancel',
            text: '网络错误',
        })
          // 处理失败会执行
      })
    },
    //删除图片
    delImg(index,id){
      for(let column_list_item of this.column_list){
        for(let row_list_item of column_list_item.row_list){
          for(let content_item of row_list_item.content){
            if(content_item.id == id){
              content_item.my_answer.splice(index,1)
            }
          }
        }
      }
    },
    //提交
    submitForm(){
      this.$vux.loading.show({
        text: '正在加载'
      })
      //answer 
      let answer_list_arr = []
      //图片上传
      let imgs_upload = []
      // imgs_upload.push(this.tmpImageUpload);
      for(let column_list_item of this.column_list){
        for(let row_list_item of column_list_item.row_list){
          for(let content_item of row_list_item.content){

            let obj = {
              id:content_item.id,
              answer:content_item.my_answer
            }
            if(content_item.type=="6"){
              content_item.my_answer = this.replaceAllNewLine(content_item.my_answer)
            }
            if( content_item.type=="11" || content_item.type == '10'){
              for(let val of obj.answer){
                let bold = ''
                if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") !=-1) {
                  //  TODO:跨域，无法转dataurl
                  //  let url = Conf.baseUrl + val;
                  //   Util.convertImgToDataURLviaCanvas(url,function(res){
                  //     console.info('res:',res)
                  //   },"image/jpeg");
                  imgs_upload.push({
                    id:obj.id,
                    file:null,
                    url:val
                  })

                }else{
                  bold = Util.dataURItoBlob(val)
                  imgs_upload.push({
                    id:obj.id,
                    file:bold
                  })
                }
                 
              }
              if(content_item.my_answer != ''){
                answer_list_arr.push({
                  id:obj.id,
                  type:content_item.type
                })
              }
            }else{
              answer_list_arr.push(obj)
            }
           
          }
        }
      }
      let params = {
        token: this.$cookie.get('token'),
        child_id: this.$route.query.child_id,
        answer_list:answer_list_arr
      }
      Api.babyLiveApi.setBabyEvaluationSheet(params,imgs_upload).then ( res => {
        if(res.errcode == 1){
          this.$router.replace({
            path:'/success',
            query: {
              id:this.$route.query.id,
              child_id:this.$route.query.child_id,
              name: 'baby_live',
              tabVal: this.$route.query.tabVal
            }
          })
          this.$vux.loading.hide()
        }else{
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    goBack(){
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      })
    }
  },
  created(){
    this.apiBabyLive()
  }
}




// WEBPACK FOOTER //
// ./src/components/baby_live.vue